const NAV = {
    header: document.getElementById('header'),
    onReady() {
        NAV.onScroll();
        NAV.addTargetAttribute();
        NAV.highlight();
        NAV.mobileNav();
        NAV.mobileSubnav();
    },
    onScroll() {
        window.addEventListener('scroll', () => {
            (window.scrollY > 100 && window.innerWidth > 1000) ? NAV.header.classList.add('onscroll') : NAV.header.classList.remove('onscroll');
        });
    },
    addTargetAttribute() {
        let host     = window.location.host;
        let navItems = document.querySelectorAll('.header__navigation__item');
        navItems.forEach(item => {
            (item.href.includes(host) === false) && (item.target = '_blank');
        });
    },
    highlight() {
        let url      = window.location.pathname;
        let urlArr   = url.split('/');
        let navItems = document.querySelectorAll('.header__navigation__item');
        if (urlArr[1] === '') return;
        navItems.forEach(item => {
            let href = item.href;
            href.includes(urlArr[1]) && item.classList.add('active');
        });
    },
    mobileNav() {
        const burger     = document.getElementById('burger');
        const navigation = document.querySelector('.header__navigation');
        if (burger === null) return;
        burger.addEventListener('click', () => {
            burger.classList.toggle('cross');
            navigation.classList.toggle('open');
        });
    },
    mobileSubnav() {
        let arrows = document.querySelectorAll('.header__subnav-icon');
        arrows.forEach(arrow => {
            arrow.addEventListener('click', () => {
                arrow.classList.toggle('open');
                arrow.previousElementSibling.classList.toggle('open');
            });
        });
    }
}